// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Button } from "semantic-ui-react";
import DashboardBarConfirm from "./DashboardBarConfirm";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardBarConfirmSupprimer = props => {
  const {
    header,
    content,
    container,
    open,
    onConfirm,
    onCancel
  } = props;
  const [loading, setLoading] = React.useState(false);
  const handleCancel = React.useCallback(() => {
    setLoading(true);
    onCancel?.();
  }, [onCancel]);
  const handleConfirm = React.useCallback(() => {
    setLoading(true);
    onConfirm?.();
  }, [onConfirm]);
  React.useEffect(() => {
    if (!open) {
      setLoading(false);
    }
  }, [open]);
  const actions = React.useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      basic: true,
      size: "small",
      icon: "cancel",
      content: "Annuler",
      disabled: loading,
      loading: loading,
      onClick: handleCancel
    }), /*#__PURE__*/_jsx(Button, {
      negative: true,
      icon: "trash",
      content: "Supprimer",
      disabled: loading,
      loading: loading,
      onClick: handleConfirm
    })]
  }), [loading, handleCancel, handleConfirm]);
  return /*#__PURE__*/_jsx(DashboardBarConfirm, {
    open: open,
    header: header,
    content: content,
    container: container,
    onCancel: handleCancel,
    onConfirm: handleConfirm,
    "data-sentry-element": "DashboardBarConfirm",
    "data-sentry-component": "DashboardBarConfirmSupprimer",
    "data-sentry-source-file": "DashboardBarConfirmSupprimer.tsx",
    children: actions
  });
};
export default DashboardBarConfirmSupprimer;